"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MNOChannel = exports.ExternalUserOrigin = exports.UserStatus = void 0;
var UserStatus;
(function (UserStatus) {
    UserStatus["Draft"] = "Draft";
    UserStatus["Registered"] = "Registered";
    UserStatus["ReVerification"] = "ReVerification";
    UserStatus["Internal"] = "Internal";
    UserStatus["Blocked"] = "Blocked";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
var ExternalUserOrigin;
(function (ExternalUserOrigin) {
    ExternalUserOrigin["CPF"] = "CPF";
    ExternalUserOrigin["Migration"] = "Migration";
})(ExternalUserOrigin || (exports.ExternalUserOrigin = ExternalUserOrigin = {}));
var MNOChannel;
(function (MNOChannel) {
    MNOChannel["MOZAMBIQUE_VODACOM"] = "MOZAMBIQUE.VODACOM";
    MNOChannel["MOZAMBIQUE_MOVITEL"] = "MOZAMBIQUE.MOVITEL";
    MNOChannel["MOZAMBIQUE_MCEL"] = "MOZAMBIQUE.MCEL";
    MNOChannel["KENYA_SAFARICOM"] = "KENYA.SAFARICOM";
})(MNOChannel || (exports.MNOChannel = MNOChannel = {}));
//# sourceMappingURL=user.js.map